import InstructorNavbar from "../components/instructor/InstructorNavbar";
import AddInstructorEducation from "../components/profile-forms/AddInstructorEducation";


const AddInstructorEducationPage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <AddInstructorEducation/>
        </>
     );
}
 
export default AddInstructorEducationPage;